import styled, { keyframes } from 'styled-components';
import { animated } from 'react-spring';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Container = styled(animated.section)`

  .inputText{
    background-color: ${(props) => props.theme.colors.modalInputSearchBackgroundColor};
    color: ${(props) => props.theme.colors.text.default};
  }

  .upload-tip {
    color: ${(props) => props.theme.uploadSurvey.uploadTipColor};
    font-size: 1.2rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .modal-body {
    padding: 24px 10px;
    margin-left: auto;
    margin-right: auto;
  }

  .errorMessage {
    color: #EB5757;
    font-family: Roboto;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    position: absolute;
    padding-left: 0;
    margin-top: 0;
    bottom: -16px;
    left: 2px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;

  input {
    width: 100%;
    height: 40px;
    border-radius: 10px;
    border: ${({ hasError }) => (hasError ? '1px solid #EB5757' : 'none')};
    background: ${(props) => props.theme.colors.UploadSurveyInputColor};
    color: ${(props) => props.theme.colors.text.placeholder};
    padding: 0 20px;
    font-size: 1.2rem;

    &::placeholder {
      color: ${(props) => props.theme.colors.text.placeholder};
    }
  }
`;

export const PageTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: fit-content;
  gap: 2px;
`;

export const PageTitle = styled.h2`
  color: ${(props) => props.theme.colors.text.default};
  font-size: 1.4rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const FilesWrapper = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: fit-content;
  gap: 16px;
  margin-bottom: 8px;

  .pipe {
    color: ${(props) => props.theme.richTextToolbar.iconColor};
    font-size: 12px;
  }
`;

export const ModelFileWrapper = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: fit-content;
  gap: 8px;
  cursor: pointer;
  text-decoration-line: none;
`;


export const ModelFileTitle = styled.h3`
  color: #0D9B9E;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration-line: underline;
`;

export const GroupInputs = styled.div`
  display:flex;
  @media (max-width: 586px) {
    display: block;
  }
  .dateErrorMessage{
    margin-top: 10px;
  }
`;
export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  margin-right: 24px;
  gap: 16px;
  position: relative;
  
  &:last-child {
    margin-right: 0;
  }

  @media (max-width: 586px) {
    width: 100%;
  }

  .custom-input-date {
    input {
      border: ${({ hasError }) => (hasError ? '1px solid #EB5757' : 'none')};
    }
  }
`;

export const InputLabel = styled.label`
  color: ${(props) => props.theme.colors.text.default};
  font-family: Roboto;
  font-size: 1.2rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const SelectorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative; 

  .custom-selector {
    border: ${({ hasError }) => (hasError ? '1px solid #EB5757' : 'none')};
    .selected  {
      color: ${(props) => props.theme.colors.text.default} !important;
    }
  }

  .inputText {
    background-color: ${(props) => props.theme.colors.backgroundColorPageInput};
    border: 1px solid ${(props) => props.theme.colors.promptOkButtonColor};
    &:focus {
      box-shadow: none;
    }
  }

  .option-label {
    color: ${(props) => props.theme.colors.text.default};
  }
`;

export const LineSeparator = styled.hr`
  border: none;
  background: #4C555C;
  height: 1px;
`;

export const DropzoneWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 16px;

  .errorMessage {
    bottom: -4px;
  }
`;

export const UploadOptionsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 16px;
  width: 100%;
`;

export const DropzoneColumn = styled.div`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
`;

export const UploadErrorMessageWrapper = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const UploadErrorMessage = styled.span`
  display: inline-block;
  color: #FFF;
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const DownloadErrorsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  cursor: pointer;


  .xlsx-icon {
    width: 14px;
    height: 14px;
  }
`;

export const DownloadErrorsText = styled.span`
  display: inline-block;
  color: #0D9B9E;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-decoration-line: underline;
`;

export const OrDivider = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 8px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    width: 1px;
    background: ${(props) => props.theme.colors.borderColor || '#4C555C'};
  }
`;

export const OrText = styled.span`
  color: ${(props) => props.theme.colors.text.placeholder || '#A1B4C4'};
  font-size: 1.2rem;
  font-weight: 500;
  text-transform: uppercase;
`;

export const CloudDriveSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1 0;
  min-width: 0;
  padding: 16px;
  cursor: pointer;
  border-width: 1px;
  border-style: dashed;
  border-radius: 4px;
  border-color: ${(props) => {
    if (props.hasError) return '#EB5757';
    if (props.isValid === true) return '#0D9B9E';
    if (props.isValid === false) return '#EB5757';
    return '#eee';
  }};
  transition: border-color 0.2s linear;

  &:focus-within,
  &:hover {
    border-color: #0D9B9E;
  }
`;

export const CloudDriveIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
`;

export const CloudDriveLabel = styled.span`
  color: ${(props) => props.theme.colors.UploadSurveyTitleColor};
  font-size: 1.2rem;
  font-weight: 400;
  text-align: center;
  margin-bottom: 8px;
`;

export const CloudDriveInputWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 327px;
  height: 40px;
  padding: 8px 16px;
  border-radius: 8px;
  gap: 8px;
  background: #4C555C;
  border: 1px solid ${(props) => {
    if (props.hasError) return '#EB5757';
    if (props.isValid === true) return '#0D9B9E';
    if (props.isValid === false) return '#EB5757';
    return 'transparent';
  }};
  transition: border-color 0.2s ease;

  &:focus-within {
    border-color: #0D9B9E;
    box-shadow: 0 0 0 2px rgba(13, 155, 158, 0.15);
  }
`;

export const CloudDriveInput = styled.input`
  flex: 1;
  height: 100%;
  border: none;
  background: transparent;
  color: ${(props) => props.theme.colors.text.default};
  font-size: 1.1rem;
  font-family: 'Roboto', sans-serif;

  &::placeholder {
    color: ${(props) => props.theme.colors.text.placeholder};
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const CloudDriveStatus = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  font-size: 1.2rem;
  font-weight: bold;
  color: ${(props) => (props.isValid ? '#0D9B9E' : '#EB5757')};

  svg {
    animation: ${spin} 1s linear infinite;
  }
`;
